import './style.scss';

export function send_message_block() {
    const block = document.querySelector('.send_message_block');
    if (!block) return;


}
